import React, { useState } from 'react'
import { ZdsCheckbox } from '@zera/components'
import { Container, Label } from './styles'

interface FilterPerTypeCheckboxRowProps {
  text: string
  Icon?: () => React.ReactNode
  type: string[]
  color: string
  checked: boolean
  onChange: (type: string[], checked: boolean, text: string) => void
  index: string
}

export const FilterPerTypeCheckboxRow = ({
  onChange,
  text,
  Icon,
  type,
  color,
  checked
}: FilterPerTypeCheckboxRowProps): JSX.Element => {
  const [isChecked, setIsChecked] = useState(checked)

  const handleLabelClick = () => {
    const newCheckedState = !isChecked
    setIsChecked(newCheckedState)
    onChange(type, newCheckedState, text)
  }

  return (
    <Container>
      <ZdsCheckbox onChange={handleLabelClick} checked={isChecked} />
      <Label color={color}>
        {Icon && Icon()}
        {text}
      </Label>
    </Container>
  )
}
